import { render, staticRenderFns } from "./produtolotes.vue?vue&type=template&id=438ca422"
import script from "./produtolotes.ts?vue&type=script&lang=js&external"
export * from "./produtolotes.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438ca422')) {
      api.createRecord('438ca422', component.options)
    } else {
      api.reload('438ca422', component.options)
    }
    module.hot.accept("./produtolotes.vue?vue&type=template&id=438ca422", function () {
      api.rerender('438ca422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/importacaonfe/produtolotes.vue"
export default component.exports